import { formatNumber } from '@/pages/campaign/logic';

import * as S from './style';

interface TotalCurrentGrass {
  totalContributionData: number;
}

export function TotalCurrentGrass({
  totalContributionData,
}: TotalCurrentGrass) {
  const totalDonationMoney = totalContributionData * 100;

  return (
    <>
      <S.Wrapper>
        <S.TextWrapper>
          <S.LeftText>누적 잔디수</S.LeftText>
          <S.RightText>{formatNumber(totalContributionData)} 개</S.RightText>
        </S.TextWrapper>
        <S.TextWrapper>
          <S.LeftText>누적 기부액</S.LeftText>
          <S.RightText>{formatNumber(totalDonationMoney)} 원</S.RightText>
        </S.TextWrapper>
        <S.TextWrapper>
          <S.LeftText>목표 기부액</S.LeftText>
          <S.RightText isLast>20,000,000 원</S.RightText>
        </S.TextWrapper>
      </S.Wrapper>
    </>
  );
}
